export default "__VITE_ASSET__CKHHLl_D__"